/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestRawBasic from '@/utils/requestRawBasic'
import requestDev from '@/utils/requestDev'
import { APIReportPHP, APICore } from '@/utils/servicesApi'
const qs = require('qs')

export function getDetailEditByScheduleId(id) {
    return requestDev({
        url: APIReportPHP() + '/scraping/schedule/get_detail_edit?id=' + id,
        method: 'GET',
    })
}
export function scrapingActionStored(data) {
    return requestRaw({
        url: APICore() + '/scraping/action_stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function getMarketplaceByScheduleId(id) {
    return requestDev({
        url: APIReportPHP() + '/scraping/schedule/get_marketplace?id=' + id,
        method: 'GET',
    })
}
export function getKeywordsByScheduleId(id) {
    return requestDev({
        url: APIReportPHP() + '/scraping/schedule/get_keywords?id=' + id,
        method: 'GET',
    })
}

export function listScraping(params) {
    return requestDev({
        url: APIReportPHP() + '/scraping/schedule/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function retryScrapingRawDetail(data) {
    return requestRaw({
        url: APICore() + '/scraping/retry_scraping_raw_detail',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function scrapingDetailProduct(data) {
    return requestRaw({
        url: APICore() + '/scraping/detail_item_product',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function monitoringActionStore(data) {
    return requestRaw({
        url: APICore() + '/monitoring/action_stored',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function scrapePreparing(data) {
    return requestRaw({
        url: APICore() + '/scraping/schedule',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function detailKeywords(id) {
    return requestRaw({
        url: APICore() + '/keywords/detail?id=' + id,
        method: 'GET',
    })
}
export function addKeywords(data) {
    return requestRaw({
        url: APICore() + '/keywords/create',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function listKeywords(data) {
    return requestRaw({
        url: APICore() + '/keywords/list-data',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function getMonitoringSortByList() {
    return requestRaw({
        url: APICore() + '/public/static/monitoring_sortby_list',
        method: 'GET',
    })
}
export function getMarketplaceList() {
    return requestRaw({
        url: APICore() + '/public/static/marketplace_list',
        method: 'GET',
    })
}

export function getMonitoringListStatus() {
    return requestRaw({
        url: APICore() + '/public/static/monitoring_status_list',
        method: 'GET',
    })
}


export function getMonitoringListAction() {
    return requestRaw({
        url: APICore() + '/public/static/monitoring_action_list',
        method: 'GET',
    })
}

export function listLinkExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/list_excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listLinkExcelMP(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/list_excel_mp',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listLinkPDFMP(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/list_pdf',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listLink(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function agentListLinkExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/omni/monitoring/list_excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function agentListLinkExcelMP(params) {
    return requestDev({
        url: APIReportPHP() + '/omni/monitoring/list_excel_mp',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function agentListLinkPDFMP(params) {
    return requestDev({
        url: APIReportPHP() + '/omni/monitoring/list_pdf',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function agentListLink(params) {
    return requestDev({
        url: APIReportPHP() + '/omni/monitoring/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listLog(params) {
    return requestDev({
        url: APIReportPHP() + '/scraping/log/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function parsingBukalapakSearchItemProduct(params) {
    return requestRaw({
        url: APICore() + '/parsing/lazada/search_get_item_product',
        method: 'POST',
        data: params
    })
}

export function parsingLazadaSearchItemProduct(params) {
    return requestRaw({
        url: APICore() + '/parsing/lazada/search_get_item_product',
        method: 'POST',
        data: params
    })
}

export function parsingTokopediaSearchItemProduct(params) {
    return requestRaw({
        url: APICore() + '/parsing/tokopedia/search_get_item_product',
        method: 'POST',
        data: params
    })
}

export function parsingShopeeSearchItemProduct(params) {
    return requestRaw({
        url: APICore() + '/parsing/shopee/search_get_item_product',
        method: 'POST',
        data: params
    })
}

export function upload_attachment(data) {
    return requestRawBasic({
        url: APICore() + '/upload/file',
        method: 'POST',
        headers: {
            "Content-Type": "multipart/form-data"
        },
        data: data // untuk array data post
    })
}

export function validationManualAdd(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/validation_manual_add',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function storedManualAdd(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/stored_manual_add',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function validationManualUpdate(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/validation_manual_update',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function storedManualUpdate(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/stored_manual_update',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function previewImport(data) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/preview_import',
        method: 'POST',
        headers: {
            "Content-Type": "multipart/form-data"
        },
        data
    })
}

export function validationImport(data) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/validation_import',
        method: 'POST',
        headers: {
            "Content-Type": "multipart/form-data"
        },
        data
    })
}

export function storedImport(data) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/stored_import',
        method: 'POST',
        headers: {
            "Content-Type": "multipart/form-data"
        },
        data
    })
}

export function storedImportHtml(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/stored_import_html',
        method: 'POST',
        data: qs.stringify(params),
    })
}

export function bookmark(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/bookmark',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function unbookmark(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/unbookmark',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function reportSummary(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/report_summary',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listDuplicate(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/list_duplicate',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function duplicate(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/duplicate',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function duplicateRestore(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/duplicate_restore',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function duplicateDelete(params) {
    return requestDev({
        url: APIReportPHP() + '/monitoring/duplicate_delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/monitoring.js